import {ClientId, FromServerId, NLOToServerId, ToServerId} from 'notebook/ELNConstants';
import {CidIdMap} from 'notebook/notes/NoteConstants';
import {addCid} from 'notebook/store/StoreTransformUtil';
import {GenericNoteLinkedScratchPlate} from 'notebook/util/NoteUtilConstants';

export type FromServerNoteLinkedScratchPlate = GenericNoteLinkedScratchPlate<FromServerId>;
export type NoteLinkedScratchPlate = GenericNoteLinkedScratchPlate<ClientId>;
export type ToServerNoteLinkedScratchPlate = GenericNoteLinkedScratchPlate<ToServerId>;

/**
 * Transform {@link FromServerNoteLinkedScratchPlate} into a {@link NoteLinkedScratchPlate}
 *
 * Invoked when loading a note into the document store. Replaces the server id with a cid,
 * which is rehydrated on save via {@link prepareForSave}.
 */
export function prepareForStore(item: FromServerNoteLinkedScratchPlate, cidIdMap: CidIdMap): void {
  addCid(item, 'scrplt-', cidIdMap);
}

/**
 * Transform a {@link NoteLinkedScratchPlate} back into a server-ready representation.
 *
 * Invoked when saving a note. Rehydrates the server id from the cidIdMap.
 */
export function prepareForSave(
  item: NoteLinkedScratchPlate,
  cidIdMap: CidIdMap
): ToServerNoteLinkedScratchPlate {
  return {
    id: cidIdMap[item.cid] as NLOToServerId['id'],
    cid: item.cid,
    type: item.type,
    name: item.name,
    data: item.data,
  };
}
